// extracted by mini-css-extract-plugin
export default {"creditbtn":"wallet_creditbtn__wxo+T","walletgrid":"wallet_walletgrid__j6RWx"};